import { useRef } from 'react';
import { Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faXmark } from '@fortawesome/free-solid-svg-icons';

import SubscriptionWizardBody, {
  SubscriptionWizardHandle,
  SubscriptionWizardProps,
} from './subscription-wizard-body';

// Standalone shell for the wizard (Settings, pipelines). Deliberately a bare
// react-bootstrap Modal rather than AppModal: AppModal owns its footer
// (Cancel + one primary action), and the wizard needs Back/Next/Save, which
// live inside the body alongside the step state that gates them.
export default function SubscriptionWizardModal({
  title,
  ...bodyProps
}: SubscriptionWizardProps & { title?: string }) {
  const defaultTitle = bodyProps.existingSubscription ? 'Edit Alarm' : 'New Alarm';
  const wizardRef = useRef<SubscriptionWizardHandle>(null);
  const requestClose = () =>
    wizardRef.current ? wizardRef.current.requestCancel() : bodyProps.onCancel();

  return (
    <Modal show onHide={requestClose} centered size="lg" className="notifications-settings">
      <Modal.Header>
        <Modal.Title
          style={{ fontSize: 14, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}
        >
          <FontAwesomeIcon icon={faBell} />
          {title ?? defaultTitle}
        </Modal.Title>
        <button
          type="button"
          className="btn btn-sm text-muted"
          style={{ marginLeft: 'auto' }}
          onClick={requestClose}
          title="Close"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </Modal.Header>
      <Modal.Body>
        <SubscriptionWizardBody ref={wizardRef} {...bodyProps} />
      </Modal.Body>
    </Modal>
  );
}
